// Orbit theme provider
import getTokensX from '@kiwicom/orbit-components/lib/getTokens';
import ThemeProviderX from '@kiwicom/orbit-components/lib/ThemeProvider';
export var getTokens = getTokensX;
export var ThemeProvider = ThemeProviderX;
